import { useEffect, useState } from 'react';
import api from '../utils/api';
import './Messages.css';

interface WaitingListEntry {
    id: number;
    email: string;
    role: string;
    created_at: string;
}

const WaitingList = () => {
    const [entries, setEntries] = useState<WaitingListEntry[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [notification, setNotification] = useState<{ message: string; type: 'success' | 'error' | 'info' } | null>(null);

    useEffect(() => {
        const fetchList = async () => {
            try {
                const response = await api.get('/v1/vitrine/waiting-list');
                const data = response.data;
                const list = Array.isArray(data) ? data : [];
                setEntries(list);
            } catch (err: any) {
                setNotification({
                    message: err.response?.data?.message || 'Failed to load waiting list',
                    type: 'error',
                });
            } finally {
                setIsLoading(false);
            }
        };

        fetchList();
    }, []);

    const formatDate = (dateStr: string) => {
        if (!dateStr) return '—';
        const d = new Date(dateStr);
        return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString(undefined, {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        });
    };

    if (isLoading) {
        return (
            <div className="messages-container">
                <div className="loader">Loading waiting list...</div>
            </div>
        );
    }

    return (
        <div className="messages-container">
            {notification && (
                <div className={`notification ${notification.type}`}>
                    {notification.type === 'success' ? '✅' : notification.type === 'error' ? '❌' : 'ℹ️'}{' '}
                    {notification.message}
                </div>
            )}

            <div className="messages-header">
                <h2>E-learning Waiting List</h2>
            </div>

            <div className="table-wrapper">
                <table className="modern-table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Email</th>
                            <th>Role</th>
                            <th>Joined</th>
                        </tr>
                    </thead>
                    <tbody>
                        {entries.length === 0 ? (
                            <tr>
                                <td colSpan={4} style={{ textAlign: 'center', padding: '2rem', opacity: 0.7 }}>
                                    No entries yet.
                                </td>
                            </tr>
                        ) : (
                            entries.map((entry, index) => (
                                <tr key={entry.id}>
                                    <td>{index + 1}</td>
                                    <td>
                                        <a href={`mailto:${entry.email}`} className="contact-email">
                                            {entry.email}
                                        </a>
                                    </td>
                                    <td>
                                        <span style={{ textTransform: 'capitalize' }}>{entry.role}</span>
                                    </td>
                                    <td>{formatDate(entry.created_at)}</td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default WaitingList;
